const normalizeRole = (role) => String(role || "").trim().toLowerCase();

export const isClientRole = (role) => ["org:client", "client"].includes(normalizeRole(role));

export const isInternalRole = (role) =>
  ["org:admin", "admin", "org:member", "member"].includes(normalizeRole(role));

export const hasRole = (has, role) => {
  if (typeof has !== "function") return false;
  try {
    return Boolean(has({ role }));
  } catch (error) {
    return false;
  }
};

export const hasClientAccess = ({ orgRole, has } = {}) =>
  isClientRole(orgRole) || hasRole(has, "org:client") || hasRole(has, "client");

export const hasInternalAccess = ({ orgRole, has } = {}) =>
  isInternalRole(orgRole) ||
  hasRole(has, "org:admin") ||
  hasRole(has, "admin") ||
  hasRole(has, "org:member") ||
  hasRole(has, "member");
